import store from 'store';
import { ACT_CMS, GET_REQUIDED_DOCUMENTATION } from 'store/actions/act';
import { GET_PARTNER_DATA, GET_PARTNER_DATA_BY_TRANSACTION_ID } from 'store/actions/ui';
import { lsGetAct } from 'helpers/store';

const Layout = () => import(/* webpackChunkName: "pages/main" */ 'layout');
const Error = () => import(/* webpackChunkName: "pages/views/error" */ 'views/Error');
const Identity = () => import(/* webpackChunkName: "pages/views/identity" */ 'views/Identity');
const Legal = () => import(/* webpackChunkName: "pages/views/legal" */ 'views/Legal');
const Act = () => import(/* webpackChunkName: "pages/views/act" */ 'views/Act');
const SignDriver = () =>
  import(/* webpackChunkName: "pages/views/signDriver" */ 'views/SignDriver');
const IdentityDriver = () =>
  import(/* webpackChunkName: "pages/views/identityDriver" */ 'views/IdentityDriver');
const OkData = () => import(/* webpackChunkName: "pages/views/okdata" */ 'views/OkData');
const SignDriverCompleted = () =>
  import(/* webpackChunkName: "pages/views/signDrivercompleted" */ 'views/SignDriverCompleted');
const FakeLleida = () =>
  import(/* webpackChunkName: "pages/views/fakeLleida" */ 'views/FakeLleida');
// Redirect to the error page
const redirectToErrorPage = (next, resource) =>
  next({
    name: 'error',
    params: { resource }
  });

// Redirect to the 404 page
// eslint-disable-next-line no-unused-vars
const redirectTo404Page = (next, path) => next({ name: '404', params: { 0: path } });

export default [
  {
    path: '/',
    component: Layout,
    beforeEnter(to, from, next) {
      if (!to.params.partnerId && to.path === '/') {
        next({ name: 'identity', params: { partnerId: process.env.DEFAULT_PARTNER } });
      } else {
        next();
      }
    },
    children: [
      {
        path: '/:partnerId(\\d+)',
        component: Identity,
        meta: { titleKey: 'identityConcession' },
        name: 'identity',
        beforeEnter(to, from, next) {
          Promise.all([
            store.dispatch(`ui/${GET_PARTNER_DATA}`, {
              id: to.params.partnerId
            }),
            store.dispatch(`act/${ACT_CMS}`, {
              partnerId: to.params.partnerId,
              patternId: 'act-paso-1'
            })
          ])
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, '');
            });
        }
      },
      {
        path: '/:partnerId/act',
        component: Act,
        meta: { titleKey: 'actData' },
        name: 'act',
        beforeEnter(to, from, next) {
          const promises = [
            store.dispatch(`act/${ACT_CMS}`, {
              partnerId: to.params.partnerId,
              patternId: 'act-paso-2'
            }),
            store.dispatch(`act/${GET_REQUIDED_DOCUMENTATION}`, {
              partnerId: to.params.partnerId,
              stepId: 'personal-documentation-required'
            }),
            store.dispatch(`act/${GET_REQUIDED_DOCUMENTATION}`, {
              partnerId: to.params.partnerId,
              stepId: 'documentation-required'
            }),
            store.dispatch(`act/${GET_REQUIDED_DOCUMENTATION}`, {
              partnerId: to.params.partnerId,
              stepId: 'external-breacks-documents-required'
            }),
            store.dispatch(`act/${GET_REQUIDED_DOCUMENTATION}`, {
              partnerId: to.params.partnerId,
              stepId: 'internal-breacks-documents-required'
            })
            // store.dispatch(`act/${GET_REQUIDED_DOCUMENTATION}`, {
            //   partnerId: to.params.partnerId,
            //   stepId: 'documents-required'
            // })
          ];
          if (!from.name) {
            promises.push(
              store.dispatch(`ui/${GET_PARTNER_DATA}`, {
                id: to.params.partnerId
              })
            );
          }
          Promise.all(promises)
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, '');
            });
        }
      },
      {
        path: '/:partnerId/ok-data',
        component: OkData,
        meta: { titleKey: 'okData' },
        name: 'ok-data',
        beforeEnter(to, from, next) {
          store
            .dispatch(`act/${ACT_CMS}`, {
              partnerId: to.params.partnerId,
              patternId: 'act-paso-2a'
            })
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, '');
            });
        }
      },
      {
        path:
          '/:transactionId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})',
        component: IdentityDriver,
        meta: { titleKey: 'identityDriver' },
        name: 'identityDriver',
        beforeEnter(to, from, next) {
          store
            .dispatch(`ui/${GET_PARTNER_DATA_BY_TRANSACTION_ID}`, {
              transactionId: to.params.transactionId
            })
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, '');
            });
        }
      },
      {
        path:
          '/:transactionId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/sign',
        component: SignDriver,
        meta: { titleKey: 'signDriverData' },
        name: 'signDriver',
        beforeEnter(to, from, next) {
          let partnerId = to.params.partnerId;
          if (to.name === 'signDriver' && lsGetAct()) {
            partnerId = lsGetAct().partnerId;
          }
          store
            .dispatch(`act/${ACT_CMS}`, {
              partnerId,
              patternId: 'act-drv-paso-2'
            })
            .then(() => next())
            .catch(() => {
              redirectToErrorPage(next, ACT_CMS);
            });
        }
      },
      {
        path:
          '/completed/:transactionId([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/ok',
        component: SignDriverCompleted,
        meta: { titleKey: 'signDriverCompleted' },
        name: 'sign-driver-completed',
        beforeEnter(to, from, next) {
          store
            .dispatch(`ui/${GET_PARTNER_DATA_BY_TRANSACTION_ID}`, {
              transactionId: to.params.transactionId
            })
            .then(data => {
              store
                .dispatch(`act/${ACT_CMS}`, {
                  partnerId: data.partnerId,
                  patternId: 'act-drv-paso-2a'
                })
                .then(() => next())
                .catch(() => {
                  redirectToErrorPage(next, '');
                });
            })
            .catch(() => {
              redirectToErrorPage(next, '');
            });
        }
      },
      {
        path: '/fakeLleida',
        name: 'fakeLleida',
        component: FakeLleida
      },
      {
        path: 'legal/:type',
        component: Legal,
        name: 'legal',
        props: { whithoutLinksFooter: true },
        meta: { titleKey: 'legal' }
      },
      {
        path: 'error',
        name: 'error',
        component: Error,
        props: { type: '500_es-ES' },
        meta: { titleKey: 'error' }
      },
      {
        path: '*',
        name: '404',
        component: Error,
        props: { type: '404_es-ES' },
        meta: { titleKey: 'notFound' }
      }
    ]
  }
];
